import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { addUserDetailApi, deleteUserApi, getUserDetailApi, getUserListApi, updateUserApi } from "services/user.service";

export const getUserList = createAsyncThunk("users/getUserList", async () => {
    try {
        const response = await getUserListApi();
        return response;
    } catch (error) {
        return error;
    }
});

export const getUserDetail = createAsyncThunk("users/getUserDetail", async (id: string) => {
    try {
        const response = await getUserDetailApi(id);
        return response;
    } catch (error) {
        return error;
    }
});

export const addUser = createAsyncThunk("users/addUserList", async (payload: any) => {
    try {
        const response = await addUserDetailApi(payload);
        toast.success("User Added Successfully", { autoClose: 3000 });
        return response;
    } catch (error) {
        toast.error(error as string, { autoClose: 3000 });
        throw error;
    }
});


export const updateUser = createAsyncThunk("users/updateUserList", async ({ id, payload }: { id: string; payload: any }) => {
    try {
        const response = updateUserApi(id, payload);
        const data = await response;
        toast.success("User updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error(error as string, { autoClose: 3000 });
        throw error;
    }
});

export const deleteUser = createAsyncThunk("users/deleteUserList", async (id: string, { dispatch }) => {
    try {
        const response = await deleteUserApi(id);
        dispatch(getUserList());
        toast.success("User deleted Successfully", { autoClose: 2000 });
        return response;
    } catch (error) {
        toast.error("User deleted Failed", { autoClose: 2000 });
        return error;
    }
});
